import { clearCurrentAtlasAuthInfo } from "@/modules/atlas-auth/clear-info";
import { ATLAS_AUTH_INFO_LOCAL_STORAGE_KEY } from "@/modules/atlas-auth/constants";
import { AtlasAuthInfo } from "@/modules/atlas-auth/types";
import { validationModule } from "@/modules/validation";
import localforage from "localforage";
import { isString } from "lodash-es";

export const getCurrentAtlasAuthInfo = async (): Promise<AtlasAuthInfo | null> => {
  const result = await localforage.getItem(ATLAS_AUTH_INFO_LOCAL_STORAGE_KEY);

  if (
    !validationModule.objectHasKey(result, "accountId") ||
    !validationModule.objectHasKey(result, "authToken") ||
    !isString(result.accountId) ||
    !isString(result.authToken)
  ) {
    await clearCurrentAtlasAuthInfo();

    return null;
  }

  return {
    accountId: result.accountId,
    authToken: result.authToken,
  };
};
